import { useContext } from "react";
import { BooleanField, Datagrid, DateField, FilterButton, List, ReferenceInput, SearchInput, SelectInput, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const ProcessList = (props) => {

    const context = useContext(AppContext)
    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN;

    const filters = [
        <SearchInput placeholder="Protocolo" source="alias" alwaysOn />,
        <ReferenceInput source="institution_branch" reference="institution-branches" sort={{ field: superAdmin ? 'institution.name' : 'name', order: 'ASC' }} perPage={99} label={'Unidade'} alwaysOn>
            <SelectInput source="name" optionText={record => superAdmin ? `${record?.institution?.name} - ${record?.name}` : record?.name} />
        </ReferenceInput>,
        <SelectInput label="Status" source="active" choices={[{ name: "Abertos", id: "true" }, { name: "Arquivados", id: "false" }]} alwaysOn />,
        <SearchInput placeholder="Cliente" source="cliente" />
    ];
    const studentPermission = !context.profile.permissions.find(item => item.resourceName === 'processes').write
    const filter = studentPermission ? { [`user.id`]: context.user.id } : undefined

    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            filter={filter}
            filters={filters}
            filterDefaultValues={{ active: true }}
            title={`Atendimentos`}
            sort={{ field: 'created_at', order: 'DESC' }}
            actions={<FilterButton />}
            {...props}
        >
            <Datagrid rowClick={(id, basePath, record) => studentPermission ? `/process-dashboard/${id}` : `/process-dashboard/${id}`}>
                <TextField source="alias" label={'Protocolo'} />
                <TextField source="client.name" label={'Cliente'} />
                {superAdmin && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(superAdmin || ProfileEnum.isGeneralProfile(context.profile.name)) && <TextField source="institution_branch.name" label={'Unidade'} />}
                <BooleanField source="active" label={'Aberto'} />
                <DateField source="created_at" label={"Criado em"} />
            </Datagrid>
        </List>
    )
}


export default ProcessList;